import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageTitle } from "@/pages/admin/AdminLayout";
import { api, fmtDate, formatErr } from "@/lib/api";
import { ADDON_LABELS } from "@/data/options";

const Card = ({ title, meta, body, link, testId }) => (
  <div className="rounded-2xl border border-border bg-card p-5" data-testid={testId}>
    <div className="flex flex-wrap justify-between gap-2">
      <p className="font-bold">{title}</p>
      <p className="text-xs text-muted-foreground">{meta}</p>
    </div>
    <p className="mt-2 text-sm whitespace-pre-wrap text-muted-foreground">{body || "-"}</p>
    {link}
  </div>
);

export default function Inbox() {
  const [data, setData] = useState({ contacts: [], addon_requests: [] });
  useEffect(() => {
    api.get("/admin/inbox").then((r) => setData(r.data)).catch((e) => toast.error(formatErr(e)));
  }, []);
  return (
    <div data-testid="admin-inbox-page">
      <PageTitle title="Inbox" sub="Contact form messages and add-on quote requests." />
      <Tabs defaultValue="contacts">
        <TabsList className="rounded-full">
          <TabsTrigger value="contacts" className="rounded-full" data-testid="inbox-tab-contacts">Contact messages ({data.contacts.length})</TabsTrigger>
          <TabsTrigger value="addons" className="rounded-full" data-testid="inbox-tab-addons">Add-on requests ({data.addon_requests.length})</TabsTrigger>
        </TabsList>
        <TabsContent value="contacts" className="space-y-3 mt-6">
          {data.contacts.length === 0 && <p className="text-muted-foreground">No messages yet.</p>}
          {data.contacts.map((c) => <Card key={c.id} testId={`contact-msg-${c.id}`} title={`${c.name} · ${c.email}`} meta={fmtDate(c.created_at)} body={`${c.subject ? `${c.subject}\n\n` : ""}${c.message}`} />)}
        </TabsContent>
        <TabsContent value="addons" className="space-y-3 mt-6">
          {data.addon_requests.length === 0 && <p className="text-muted-foreground">No add-on requests yet.</p>}
          {data.addon_requests.map((r) => (
            <Card key={r.id} testId={`addon-req-${r.id}`} title={`${r.name} · ${r.services.map((s) => ADDON_LABELS[s]).join(", ")}`} meta={fmtDate(r.created_at)} body={r.details}
              link={<Link to={`/admin/applicants/${r.application_id}`} className="mt-3 inline-block text-sm font-bold text-primary">Open member</Link>} />
          ))}
        </TabsContent>
      </Tabs>
    </div>
  );
}
